import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createBlock as _createBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4941b2a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Väntar på konto", -1))
const _hoisted_2 = {
  class: "table-responsive",
  style: {"max-height":"250px"}
}
const _hoisted_3 = { class: "table table-striped table-hover" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, null, -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  colspan: "5",
  class: "text-center"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  class: "text-center"
}, "Det finns inga nyanställda att godkänna", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["onClick", "title"]
const _hoisted_12 = { class: "marker-wrapper" }
const _hoisted_13 = {
  key: 0,
  class: "marker green"
}
const _hoisted_14 = { class: "text-end" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_16 = { autocomplete: "off" }
const _hoisted_17 = { disabled: "" }
const _hoisted_18 = { class: "row mb-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-firstName",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Förnamn:", -1))
const _hoisted_20 = { class: "col-md-4 col-xs-12" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-lastName",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Efternamn:", -1))
const _hoisted_22 = { class: "col-md-4 col-xs-12" }
const _hoisted_23 = { class: "row mb-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-personalIdentityNumber",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Personnummer:", -1))
const _hoisted_25 = { class: "col-md-10 col-xs-12" }
const _hoisted_26 = { class: "row mb-3" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-address",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Adress:", -1))
const _hoisted_28 = { class: "col-md-10 col-xs-12" }
const _hoisted_29 = { class: "row mb-3" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-address2",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Adress 2:", -1))
const _hoisted_31 = { class: "col-md-10 col-xs-12" }
const _hoisted_32 = { class: "row mb-3" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-postalCode",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Postnummer:", -1))
const _hoisted_34 = { class: "col-md-4 col-xs-12" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-city",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Ort:", -1))
const _hoisted_36 = { class: "col-md-4 col-xs-12" }
const _hoisted_37 = { class: "row mb-3" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-phone",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Hemtelefon:", -1))
const _hoisted_39 = { class: "col-md-4 col-xs-12" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-mobile",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Mobiltelefon:", -1))
const _hoisted_41 = { class: "col-md-4 col-xs-12" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_43 = { class: "row mb-3" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-relativeName",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Anhörig:", -1))
const _hoisted_45 = { class: "col-md-4 col-xs-12" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-relativeRelation",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Relation:", -1))
const _hoisted_47 = { class: "col-md-4 col-xs-12" }
const _hoisted_48 = ["value"]
const _hoisted_49 = { class: "row mb-3" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-relativePhone",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Anhörig telefon:", -1))
const _hoisted_51 = { class: "col-md-10 col-xs-12" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_53 = { class: "row mb-3" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-bankClearing",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Clearingnummer:", -1))
const _hoisted_55 = { class: "col-md-4 col-xs-12" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-bankAccount",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Bankkonto:", -1))
const _hoisted_57 = { class: "col-md-4 col-xs-12" }
const _hoisted_58 = { class: "row mb-3" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-campaign",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Kampanj:", -1))
const _hoisted_60 = { class: "col-md-10 col-xs-12" }
const _hoisted_61 = ["value"]
const _hoisted_62 = { class: "row mb-3" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-employmentDate",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Anställningsdatum:", -1))
const _hoisted_64 = { class: "col-md-4 col-xs-12" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-employmentForm",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Anställningsform:", -1))
const _hoisted_66 = { class: "col-md-4 col-xs-12" }
const _hoisted_67 = ["value"]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_69 = { class: "row mb-3" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-info",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Övrig info:", -1))
const _hoisted_71 = { class: "col-md-10 col-xs-12" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_73 = { class: "row mb-3" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-createdBy",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Post skapad av:", -1))
const _hoisted_75 = { class: "col-md-4 col-xs-12" }
const _hoisted_76 = ["value"]
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-createdAt",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Post skapad:", -1))
const _hoisted_78 = { class: "col-md-4 col-xs-12" }
const _hoisted_79 = ["value"]
const _hoisted_80 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-accountsCreatedBy",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Konton skapade av:", -1))
const _hoisted_82 = { class: "col-md-4 col-xs-12" }
const _hoisted_83 = ["value"]
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-accountsCreatedAt",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Konton skapade:", -1))
const _hoisted_85 = { class: "col-md-4 col-xs-12" }
const _hoisted_86 = ["value"]
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "E-post och lösenord", -1))
const _hoisted_89 = { class: "row has-validation mb-3" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-email",
  class: "col-md-2 col-xs-12 col-form-label"
}, "E-post:", -1))
const _hoisted_91 = { class: "col-md-8 col-xs-12 mb-2 mb-md-0" }
const _hoisted_92 = { class: "input-group" }
const _hoisted_93 = ["disabled"]
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "input-group-text",
  id: "form-email-addon"
}, "@koncepta.se", -1))
const _hoisted_95 = { class: "col-md-2 col-xs-12 d-grid" }
const _hoisted_96 = ["disabled"]
const _hoisted_97 = { key: 0 }
const _hoisted_98 = {
  key: 0,
  class: "row has-validation mb-3"
}
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-campaign-email",
  class: "col-md-2 col-xs-12 col-form-label"
}, null, -1))
const _hoisted_100 = { class: "col-md-8 col-xs-12 mb-2 mb-md-0" }
const _hoisted_101 = { class: "input-group" }
const _hoisted_102 = ["disabled"]
const _hoisted_103 = {
  class: "input-group-text",
  id: "form-campaignEmail-addon"
}
const _hoisted_104 = { class: "col-md-2 col-xs-12 d-grid" }
const _hoisted_105 = ["disabled"]
const _hoisted_106 = { key: 0 }
const _hoisted_107 = { class: "row mb-3" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-password",
  class: "col-md-2 col-xs-12 col-form-label"
}, "Lösenord:", -1))
const _hoisted_109 = { class: "col-md-8 col-xs-12 mb-2 mb-md-0" }
const _hoisted_110 = ["disabled"]
const _hoisted_111 = { class: "col-md-2 col-xs-12 d-grid" }
const _hoisted_112 = ["disabled"]
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Skapa konton i AD och affärssystem", -1))
const _hoisted_115 = {
  key: 1,
  class: "row"
}
const _hoisted_116 = { class: "col" }
const _hoisted_117 = {
  class: "alert alert-success alert-dismissible fade show",
  role: "alert"
}
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "alert",
  "aria-label": "Close"
}, null, -1))
const _hoisted_119 = { class: "row mb-3" }
const _hoisted_120 = { class: "col d-grid" }
const _hoisted_121 = ["disabled"]
const _hoisted_122 = { key: 0 }
const _hoisted_123 = {
  key: 2,
  class: "row mb-3"
}
const _hoisted_124 = { class: "col d-grid" }
const _hoisted_125 = ["disabled"]
const _hoisted_126 = { key: 0 }
const _hoisted_127 = {
  key: 3,
  class: "row mb-3"
}
const _hoisted_128 = { class: "col d-grid" }
const _hoisted_129 = ["disabled"]
const _hoisted_130 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_messages = _resolveComponent("messages")!
  const _component_FormInputPersonalIdentityNumber = _resolveComponent("FormInputPersonalIdentityNumber")!
  const _component_FormInputPostalCode = _resolveComponent("FormInputPostalCode")!
  const _component_FormInputPhoneNumber = _resolveComponent("FormInputPhoneNumber")!
  const _component_FormInputDate = _resolveComponent("FormInputDate")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "float-end btn btn-outline-dark",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args)))
    }, [
      _createVNode(_component_fa_icon, { icon: "sync-alt" })
    ]),
    _hoisted_1,
    _createVNode(_component_messages, { ref: "errorHandler" }, null, 512),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _hoisted_4,
            _createElementVNode("th", {
              scope: "col",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sort('firstName'))),
              class: _normalizeClass(["sortable", {
              sorted: _ctx.sortBy === 'firstName',
              reverse: _ctx.sortReverse,
            }])
            }, " Förnamn ", 2),
            _createElementVNode("th", {
              scope: "col",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sort('lastName'))),
              class: _normalizeClass(["sortable", {
              sorted: _ctx.sortBy === 'lastName',
              reverse: _ctx.sortReverse,
            }])
            }, " Efternamn ", 2),
            _createElementVNode("th", {
              scope: "col",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sort('campaign'))),
              class: _normalizeClass(["sortable", {
              sorted: _ctx.sortBy === 'campaign',
              reverse: _ctx.sortReverse,
            }])
            }, " Kampanj ", 2),
            _hoisted_5
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.loadingNewEmployees)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                _createElementVNode("td", _hoisted_7, [
                  _createVNode(_component_fa_icon, {
                    icon: "spinner",
                    spin: ""
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.loadingNewEmployees && _ctx.newEmployees.length === 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_8, _hoisted_10))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newEmployees, (e) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: e.id,
              onClick: ($event: any) => (_ctx.selectNewEmployee(e)),
              role: "button",
              title: `ID: ${e.id}`
            }, [
              _createElementVNode("td", _hoisted_12, [
                (e.employeeNumber)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", null, _toDisplayString(e.firstName), 1),
              _createElementVNode("td", null, _toDisplayString(e.lastName), 1),
              _createElementVNode("td", null, _toDisplayString(e.campaign.abbreviation), 1),
              _createElementVNode("td", _hoisted_14, [
                _createVNode(_component_fa_icon, { icon: "pen-to-square" })
              ])
            ], 8, _hoisted_11))
          }), 128))
        ])
      ])
    ]),
    (_ctx.employee)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_15,
          _createElementVNode("form", _hoisted_16, [
            _createElementVNode("fieldset", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "form-firstName",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.employee.firstName) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.employee.firstName]
                  ])
                ]),
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "form-lastName",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.employee.lastName) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.employee.lastName]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_FormInputPersonalIdentityNumber, {
                    modelValue: _ctx.employee.personalIdentityNumber,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.employee.personalIdentityNumber) = $event)),
                    id: "form-personalIdentityNumber"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "form-address",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.employee.address) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.employee.address]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("div", _hoisted_31, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "form-address2",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.employee.address2) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.employee.address2]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_component_FormInputPostalCode, {
                    modelValue: _ctx.employee.postalCode,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.employee.postalCode) = $event)),
                    id: "form-postalCode"
                  }, null, 8, ["modelValue"])
                ]),
                _hoisted_35,
                _createElementVNode("div", _hoisted_36, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "form-city",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.employee.city) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.employee.city]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_component_FormInputPhoneNumber, {
                    modelValue: _ctx.employee.phoneHome,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.employee.phoneHome) = $event)),
                    id: "form-phone"
                  }, null, 8, ["modelValue"])
                ]),
                _hoisted_40,
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_component_FormInputPhoneNumber, {
                    modelValue: _ctx.employee.phoneMobile,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.employee.phoneMobile) = $event)),
                    id: "form-mobile"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _hoisted_42,
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "form-relativeName",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.employee.relativeName) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.employee.relativeName]
                  ])
                ]),
                _hoisted_46,
                _createElementVNode("div", _hoisted_47, [
                  _withDirectives(_createElementVNode("select", {
                    id: "form-relativeRelation",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.employee.relativeRelation) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relationTypes, (rt) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: rt.id,
                        value: rt
                      }, _toDisplayString(rt.name), 9, _hoisted_48))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.employee.relativeRelation]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("div", _hoisted_51, [
                  _createVNode(_component_FormInputPhoneNumber, {
                    modelValue: _ctx.employee.relativePhone,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.employee.relativePhone) = $event)),
                    id: "form-relativePhone"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _hoisted_52,
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                _createElementVNode("div", _hoisted_55, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "form-bankClearing",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.employee.bankClearing) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.employee.bankClearing]
                  ])
                ]),
                _hoisted_56,
                _createElementVNode("div", _hoisted_57, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "form-bankAccount",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.employee.bankAccount) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.employee.bankAccount]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _hoisted_59,
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "form-campaign",
                    value: `${_ctx.employee.campaign.id} : ${_ctx.employee.campaign.name}`
                  }, null, 8, _hoisted_61)
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _createElementVNode("div", _hoisted_64, [
                  _createVNode(_component_FormInputDate, {
                    modelValue: _ctx.employee.employmentDate,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.employee.employmentDate) = $event)),
                    id: "form-employmentDate"
                  }, null, 8, ["modelValue"])
                ]),
                _hoisted_65,
                _createElementVNode("div", _hoisted_66, [
                  _withDirectives(_createElementVNode("select", {
                    id: "form-employmentForm",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.employee.employmentForm) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employmentForms, (ef) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: ef.id,
                        value: ef
                      }, _toDisplayString(ef.name), 9, _hoisted_67))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.employee.employmentForm]
                  ])
                ])
              ]),
              _hoisted_68,
              _createElementVNode("div", _hoisted_69, [
                _hoisted_70,
                _createElementVNode("div", _hoisted_71, [
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    id: "form-info",
                    rows: "3",
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.employee.info) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.employee.info]
                  ])
                ])
              ]),
              _hoisted_72,
              _createElementVNode("div", _hoisted_73, [
                _hoisted_74,
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("input", {
                    type: "text",
                    readonly: "",
                    class: "form-control-plaintext",
                    id: "form-createdBy",
                    value: _ctx.employee.createdBy?.fullName
                  }, null, 8, _hoisted_76)
                ]),
                _hoisted_77,
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("input", {
                    type: "text",
                    value: _ctx.fmt.fmtDateTime(_ctx.employee.createdAt),
                    id: "form-createdAt",
                    readonly: "",
                    class: "form-control-plaintext"
                  }, null, 8, _hoisted_79)
                ])
              ]),
              (_ctx.employee.accountsCreatedBy || _ctx.employee.accountsCreatedAt)
                ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                    _hoisted_81,
                    _createElementVNode("div", _hoisted_82, [
                      _createElementVNode("input", {
                        type: "text",
                        readonly: "",
                        class: "form-control-plaintext",
                        id: "form-accountsCreatedBy",
                        value: _ctx.employee.accountsCreatedBy != null ? _ctx.employee.accountsCreatedBy?.fullName : '-'
                      }, null, 8, _hoisted_83)
                    ]),
                    _hoisted_84,
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("input", {
                        type: "text",
                        value: _ctx.employee.accountsCreatedAt != null ? _ctx.fmt.fmtDateTime(_ctx.employee.accountsCreatedAt) : '-',
                        id: "form-accountsCreatedAt",
                        readonly: "",
                        class: "form-control-plaintext"
                      }, null, 8, _hoisted_86)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_87,
            _createElementVNode("fieldset", null, [
              _hoisted_88,
              _createVNode(_component_messages, { ref: "emailValidationErrorHandler" }, null, 512),
              _createElementVNode("div", _hoisted_89, [
                _hoisted_90,
                _createElementVNode("div", _hoisted_91, [
                  _createElementVNode("div", _hoisted_92, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      ref: "formEmail",
                      id: "form-email",
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.companyEmailUsername) = $event)),
                      "aria-describedby": "form-email-addon",
                      disabled: _ctx.checkingCampaignEmail || _ctx.employee.employeeNumber !== null
                    }, null, 8, _hoisted_93), [
                      [_vModelText, _ctx.formData.companyEmailUsername]
                    ]),
                    _hoisted_94
                  ])
                ]),
                _createElementVNode("div", _hoisted_95, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (_ctx.checkEmailAvailable(_ctx.companyEmailAddress, _ctx.$refs.formEmail, 'company')), ["prevent"])),
                    disabled: _ctx.checkingCompanyEmail || _ctx.employee.employeeNumber !== null
                  }, [
                    (!_ctx.checkingCompanyEmail)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_97, "Kontrollera"))
                      : (_openBlock(), _createBlock(_component_fa_icon, {
                          key: 1,
                          icon: "spinner"
                        }))
                  ], 8, _hoisted_96)
                ])
              ]),
              (!_ctx.employee.campaign.isAdministration)
                ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                    _hoisted_99,
                    _createElementVNode("div", _hoisted_100, [
                      _createElementVNode("div", _hoisted_101, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          ref: "formCampaignEmail",
                          id: "form-campaign-email",
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.campaignEmailUsername) = $event)),
                          "aria-describedby": "form-campaignEmail-addon",
                          disabled: _ctx.checkingCampaignEmail || _ctx.employee.employeeNumber !== null
                        }, null, 8, _hoisted_102), [
                          [_vModelText, _ctx.formData.campaignEmailUsername]
                        ]),
                        _createElementVNode("span", _hoisted_103, "@" + _toDisplayString(_ctx.campaignEmailDomain), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_104, [
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (_ctx.checkEmailAvailable(_ctx.campaignEmailAddress, _ctx.$refs.formCampaignEmail, 'campaign')), ["prevent"])),
                        disabled: _ctx.checkingCampaignEmail || _ctx.employee.employeeNumber !== null
                      }, [
                        (!_ctx.checkingCampaignEmail)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_106, "Kontrollera"))
                          : (_openBlock(), _createBlock(_component_fa_icon, {
                              key: 1,
                              icon: "spinner"
                            }))
                      ], 8, _hoisted_105)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_107, [
                _hoisted_108,
                _createElementVNode("div", _hoisted_109, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "form-password",
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.password) = $event)),
                    disabled: _ctx.employee.employeeNumber !== null
                  }, null, 8, _hoisted_110), [
                    [_vModelText, _ctx.formData.password]
                  ])
                ]),
                _createElementVNode("div", _hoisted_111, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[26] || (_cache[26] = _withModifiers(($event: any) => (_ctx.generateEmployeePassword()), ["prevent"])),
                    disabled: _ctx.employee.employeeNumber !== null
                  }, " Generera ", 8, _hoisted_112)
                ])
              ]),
              _hoisted_113,
              _hoisted_114,
              _createVNode(_component_messages, { ref: "createAccountsErrorHandler" }, null, 512),
              (_ctx.employee.employeeNumber)
                ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                    _createElementVNode("div", _hoisted_116, [
                      _createElementVNode("div", _hoisted_117, [
                        _createTextVNode(" Konton i AD och Visma är skapade. "),
                        _createVNode(_component_router_link, {
                          to: { name: 'ShowEmployee', params: { employeeNumber: _ctx.employee.employeeNumber } }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("[ Visa ]")
                          ]),
                          _: 1
                        }, 8, ["to"]),
                        _hoisted_118
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_119, [
                _createElementVNode("div", _hoisted_120, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (_ctx.createAccounts(_ctx.employee!)), ["prevent"])),
                    disabled: _ctx.creatingAccounts || _ctx.employee.employeeNumber !== null
                  }, [
                    (!_ctx.creatingAccounts)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_122, "Skapa konto"))
                      : (_openBlock(), _createBlock(_component_fa_icon, {
                          key: 1,
                          icon: "spinner"
                        }))
                  ], 8, _hoisted_121)
                ])
              ]),
              (_ctx.employee.employeeNumber)
                ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                    _createElementVNode("div", _hoisted_124, [
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: _cache[28] || (_cache[28] = _withModifiers(($event: any) => (_ctx.notifyHR(_ctx.employee!)), ["prevent"])),
                        disabled: _ctx.notifyingHR
                      }, [
                        (!_ctx.notifyingHR)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_126, "Meddela HR"))
                          : (_openBlock(), _createBlock(_component_fa_icon, {
                              key: 1,
                              icon: "spinner"
                            }))
                      ], 8, _hoisted_125)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.employee.employeeNumber)
                ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                    _createElementVNode("div", _hoisted_128, [
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: _cache[29] || (_cache[29] = _withModifiers(($event: any) => (_ctx.notifyManager(_ctx.employee!)), ["prevent"])),
                        disabled: _ctx.notifyingManager
                      }, [
                        (!_ctx.notifyingManager)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_130, "Meddela chef"))
                          : (_openBlock(), _createBlock(_component_fa_icon, {
                              key: 1,
                              icon: "spinner"
                            }))
                      ], 8, _hoisted_129)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}